import { render, staticRenderFns } from "./MailcodeSelect.vue?vue&type=template&id=2395b54f&"
import script from "./MailcodeSelect.vue?vue&type=script&lang=js&"
export * from "./MailcodeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports